import {
  Button,
  Card,
  CardContent,
  Grid,
  TextField,
  Typography,
  Divider,
  Modal, // Keep Modal
  Box,   // Keep Box
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Table,
} from "@mui/material";
import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import HOST_URL from "../../../utils/Url";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import ToastApp from "../../../ToastApp";
import Autocomplete from "@mui/material/Autocomplete";
import { Margin } from "@mui/icons-material";
import nopdf from '../../../assets/images/nopdf.png'
import moment from 'moment';
import { getSecureDevId } from "../../../utils/storageHelpers";
import TablePagination from "@mui/material/TablePagination";
import CircularProgress from "@mui/material/CircularProgress";
import { useLocation } from "react-router-dom";
// Define the style for the modal content box
const modalStyle = {
  width: { xs: '85%', sm: '60%', md: '400px' },
  maxWidth: '350px',

  bgcolor: "background.paper",
  borderRadius: '12px',
  boxShadow: 24,

  p: { xs: 2, sm: 3 },

  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: 2,

  maxHeight: "80vh",
  overflowY: "auto"
};

type Props = {};

const SplitPDF = (props: Props) => {

  const [selectedRows, setSelectedRows] = useState<any>([]);
  const [selectedRow, setSelectedRow] = useState<any>([]);

  let navigate = useNavigate();
  const { i18n, t } = useTranslation();
  const location = useLocation();
  const [isSubmittingSplit, setIsSubmittingSplit] = useState(false);
  const [toaster, setToaster] = useState(false);
  const [tableData, setTableData] = useState<any>([]);
  const [DocFileOption, setDocFileOption] = useState([{ value: "-1", label: t("text.SelectFileType") }]);
  const [StatusOption, setStatusOption] = useState([{ value: "-1", label: t("text.SelectFileStatus") }]);
  const [DocOption, setDocOption] = useState([{ value: "-1", label: t("text.SelectFileNo") }]);

  const [departmentOptions, setDepartmentOptions] = useState<any[]>([]);
  const [selectedDepartment, setSelectedDepartment] = useState<any>(null);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  // State to control modal visibility and background blur
  const [active, setActive] = useState(false);
  const [splitSuccessData, setSplitSuccessData] = useState<any[]>([]);

  const devId = getSecureDevId();

  function formatDate(dateString: any) {
    if (!dateString) return ""; // Return empty string if date is not provided
    return moment(dateString).format('DD-MM-YYYY');
  }

  useEffect(() => {
    const dataString = localStorage.getItem("userdata");
    getFileType();
    getFileStatus();
    getDoc();
    fetchDepartments();
  }, []);


  // SplitPDF.tsx में - यह useEffect पहले से होना चाहिए
  // useEffect(() => {
  //   if (location.state?.selectedDocMids && location.state.selectedDocMids.length > 0 && DocOption.length > 1) {
  //     const selectedMids = location.state.selectedDocMids;
  //     const targetId = selectedMids[0];

  //     console.log("🟢 Target ID:", targetId, "type:", typeof targetId);

  //     // Loop through all options to find match
  //     let matchedOption = null;
  //     for (let i = 0; i < DocOption.length; i++) {
  //       const opt = DocOption[i];
  //       // Compare as string
  //       if (String(opt.value) === String(targetId)) {
  //         matchedOption = opt;
  //         break;
  //       }
  //       // Compare as number
  //       if (Number(opt.value) === Number(targetId)) {
  //         matchedOption = opt;
  //         break;
  //       }
  //     }

  //     console.log("🟢 Matched Option:", matchedOption);

  //     if (matchedOption) {
  //       formik.setFieldValue("docMid", String(matchedOption.value));
  //       setTimeout(() => {
  //         getDocMng(String(matchedOption.value), selectedDepartment?.value);
  //       }, 500);
  //       window.history.replaceState({}, document.title);
  //     } else {
  //       // अगर match नहीं मिला, तो DocOption का पहला कुछ ऑप्शन दिखाएँ
  //       console.log("🟢 Sample options:", DocOption.slice(0, 10).map(opt => ({ value: opt.value, type: typeof opt.value })));
  //     }
  //   }
  // }, [location, DocOption]);

  useEffect(() => {
    if (location.state?.selectedDocMids && location.state.selectedDocMids.length > 0 && DocOption.length > 1) {
      const selectedMids = location.state.selectedDocMids;
      const targetId = selectedMids[0];

      let matchedOption = null;
      for (let i = 0; i < DocOption.length; i++) {
        const opt = DocOption[i];
        // Compare as string OR number
        if (String(opt.value) === String(targetId) || Number(opt.value) === Number(targetId)) {
          matchedOption = opt;
          break;
        }
      }

      console.log("🟢 Matched Option:", matchedOption);

      if (matchedOption) {
        // ⭐ Important: value को string में store करें
        // Autocomplete compare के लिए string ही use करें
        const valueToSet = String(matchedOption.value);
        formik.setFieldValue("docMid", valueToSet);

        console.log("🟢 formik.values.docMid set to:", valueToSet);
        console.log("🟢 Type of formik.values.docMid:", typeof valueToSet);

        setTimeout(() => {
          getDocMng(valueToSet, selectedDepartment?.value);
        }, 500);

        window.history.replaceState({}, document.title);
      }
    }
  }, [location, DocOption]);

  // State to track whether "Select All in Department" is checked
  const [selectAllDept, setSelectAllDept] = useState(false);

  // Function to select/unselect all rows of selected department
  const handleSelectAllDepartment = (checked: boolean) => {
    setSelectAllDept(checked); // update the checkbox state

    if (!selectedDepartment) {
      toast.warning("Please select a department first.");
      return;
    }

    setTableData((prevTableData: any) =>
      prevTableData.map((row: any) =>
        row.divisionid === selectedDepartment.value
          ? { ...row, isSelected: checked }
          : row
      )
    );
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const getDocMng = (docId?: any, deptId?: any) => {

  // ✅ FIX: agar event aa gaya to ignore
  if (docId && typeof docId === "object") {
    docId = undefined;
  }

  const collectData = {
    modal: "",
    fromDate: formik.values.fDate || "",
    toDate: formik.values.perUt || "",
    filestatus: "",
    textSearch: formik.values.textSearch || "",

    docMid: String(docId ?? formik.values.docMid ?? ""), // ✅ key line

    fileTypId: "",
    divisionid: String(deptId ?? selectedDepartment?.value ?? ""),
    user_Id: -1
  };

  console.log("🔥 PAYLOAD:", collectData);
    axios
      .post(HOST_URL.HOST_URL2 + `DocMangr/GetDocMangrForIndex`, collectData)
      .then((res) => {

        const arr = res.data.data.map((item: any) => ({
          id: item.pdFid,
          fileNo: item.fileNo,
          docMid: item.docMid,
          fileDef: item.fileDef,
          synopsis: item.synopsis,
          fileType: item.fileType,
          subject: item.subject,
          pdfName: item.pdfName,
          pdFid: item.pdFid,
          divisionid: item.divisionid,
          division_name: item.division_name,
          isSelected: false
        }));

        setTableData(arr);

      })
      .catch((error) => {

        console.error(error);
        toast.error("Failed to fetch documents");

      });
  };
  const resetFormUI = () => {

    // formik reset
    formik.resetForm();

    // department reset
    setSelectedDepartment(null);

    // table reset
    setTableData([]);

    // checkbox reset
    setSelectAllDept(false);

    // pagination reset
    setPage(0);

  };
  const AddSplitPdf = async () => {

    let array1: any[] = [];
    let hasSelection = false;

    for (let row of tableData) {

      if (row.isSelected) {

        hasSelection = true;

        array1.push({
          docMid: row.docMid,
          divisionid: row.divisionid,
          docMangrSplits: [
            {
              chkSplit: true,
              pdfName: row.pdfName,
              pdFid: row.pdFid
            }
          ]
        })

      }

    }

    if (!hasSelection) {
      toast.warning("Please select at least one PDF");
      return;
    }

    const collectData = {
      docMangrReqForSplit: array1
    }

    try {

      setIsSubmittingSplit(true);

      const response = await axios.post(
        HOST_URL.HOST_URL2 + `SplitPdf/AddUpdateSplitPdf`,
        collectData
      );

      if (response.data.status === 1) {

        toast.success("Split request submitted successfully!");

        // 👇 नया कोड: स्प्लिट की गई फाइलों की docMid इकट्ठा करें
        const selectedDocMids = array1.map(item => item.docMid);
        setSplitSuccessData(selectedDocMids); // state में सेव करें
        // 👆 नया कोड समाप्त
        setActive(true);

        // checkbox reset
        setTableData((prev: any[]) =>
          prev.map(row => ({
            ...row,
            isSelected: false
          }))
        );

        // ⭐ FULL UI RESET
        setActive(true);

// 🔥 delay reset (VERY IMPORTANT)
setTimeout(() => {
  resetFormUI();
}, 300);

      } else {

        toast.error(response.data.message || "Error processing split");

      }

    }
    catch (error) {

      toast.error("Error submitting split request");

    }
    finally {

      setIsSubmittingSplit(false);

    }

  };

  // 👇 यह नया फंक्शन जोड़ें
  const handleGoToIndexing = () => {
    navigate('/DocManagement/DocumentIndexing', {
      state: { selectedDocMids: splitSuccessData }
    });
    setActive(false);
  };

  const getFileType = () => {
    const collectData = { docID: -1, parentDocId: -1, userId: "", };
    axios
      .post(HOST_URL.HOST_URL2 + `OtherDocType/GetOtherDocType`, collectData)
      .then((res) => {
        const arr = res.data.data.map((item: any) => ({
          label: item.doc_Name,
          value: item.docID
        }));
        setDocFileOption([{ value: "-1", label: t("text.SelectFileType") }, ...arr]); // Add default option back
      }).catch(err => console.error("Failed to get file types", err));
  };

  const getDoc = () => {
    const collectData = {
      docMid: -1, fileTypId: -1,
      //@ts-ignore
      divisionid: devId === null || devId === "null" ? "" : Number(devId),
      subsubjId: -1, user_Id: -1, fileNo: "",
      subDeptID: -1,
      synopsis: "",
      complt: ""
    };
    axios
      .post(HOST_URL.HOST_URL2 + `DocMangr/GetDocMangr`, collectData)
      .then((res) => {
        const arr = res.data.data.map((item: any) => ({
          label: item.fileNo ? `${item.fileNo} (${item.synopsis})` : "_ _",
          value: item.docMid
        }));
        setDocOption([{ value: "-1", label: t("text.SelectFileNo") }, ...arr]); // Add default option back
      }).catch(err => console.error("Failed to get docs", err));
  };

  const getFileStatus = () => {
    const collectData = {};
    axios
      .post(HOST_URL.HOST_URL2 + `FileStatus/GetFileStatus`, collectData)
      .then((res) => {
        var array = [];
        for (let index = 0; index < res.data.data.length; index++) {
          array.push({
            label: res.data.data[index]["fStatus"],
            value: res.data.data[index]["fStatus"],
          });
        }
        setStatusOption([{ value: "-1", label: t("text.SelectFileStatus") }, ...array]); // Add default option back
      }).catch(err => console.error("Failed to get file status", err));
  };

  const fetchDepartments = async () => {
    try {
      const response = await axios.post(
        HOST_URL.HOST_URL2 + `NewNodeMaster/GetNewNodeMaster`,
        {
          id: -1,
          nodeID: -1,
          titleID: -1,
        }
      );

      const departments = response.data.data || [];

      const deptOptions = departments.map((dept: any) => ({
        label: dept.name,
        value: dept.id,
      }));

      setDepartmentOptions(deptOptions);

    } catch (error) {
      toast.error("Failed to fetch departments");
    }
  };

  const handleInputChange = (id: number, columnName: string, checked: boolean) => {
    setTableData((prevTableData: any) =>
      prevTableData.map((row: any) =>
        row.id === id ? { ...row, [columnName]: checked } : row
      )
    );
  };
  const handleSelectAll = (checked: boolean) => {
    const start = page * rowsPerPage;
    const end = page * rowsPerPage + rowsPerPage;

    const updatedData = tableData.map((row: any, index: number) => {
      if (index >= start && index < end) {
        return { ...row, isSelected: checked };
      }
      return row;
    });

    setTableData(updatedData);
  };

  const formik = useFormik({
    initialValues: {
      docMid: "", fDate: "", perUt: "", textSearch: "",
      // Keep other initial values if needed, but these are the main search ones
      // ... other fields ...
      fileNo: "", fileDef: "", synopsis: "", complt: "", fileType: "", subj: "",
      partNo: "", pFileNo: "", userId: "", perFr: "", authPersn: "",
      subsubjId: 0, sub_Subject_Name: "", divisionid: 0, division_name: "",
      filestatus: "", fileTypId: "", createdate: "", user_Id: 1,
    },
    onSubmit: async (values) => {
      // The main action is triggered by the search button (getDocMng)
      // This onSubmit might not be strictly needed unless you have other form actions
      console.log("Form submitted (though search is manual)", values);
    },
  });

  // Removed handleCheckboxChange as handleInputChange covers the checkbox state now.

  const back = useNavigate();

  return (
    // Use React Fragment to allow modal as a sibling to the main content div
    <>
      {/* Wrap main content for blurring */}
      <div
        style={{
           padding: " 5px",
       opacity: active ? 0.5 : 1 ,// Apply blur when active
          transition: "filter 0.3s ease-out", // Smooth transition for blur
          pointerEvents: active ? "none" : "auto", // Prevent interaction with blurred background
          // The rest of your existing styles for this div
          backgroundColor: "#ffffff",
          borderRadius: "5px",
          border: ".5px solid #42AEEE",
          // marginTop: "4vh",
        }}
      >
        <CardContent>
          {/* <Typography
            variant="h5"
            textAlign="center"
            style={{ fontSize: "18px", fontWeight: 500 }}
          >
            {t("text.SplitPdfToJump")}
          </Typography> */}

        <Grid container alignItems="center" spacing={1}>
  
  {/* Back Button */}
  <Grid item>
    <Button
      onClick={() => back(-1)}
      variant="contained"
      sx={{
        minWidth: "40px",
        height: "40px",
        borderRadius: "8px",
        backgroundColor: `var(--header-background)`
      }}
    >
      <ArrowBackSharpIcon />
    </Button>
  </Grid>

  {/* Title */}
  <Grid item xs>
    <Typography
      variant="h6"
      sx={{
        fontSize: { xs: "16px", sm: "18px" },
        fontWeight: 500
      }}
    >
      {t("text.SplitPdfToJump")}
    </Typography>
  </Grid>

</Grid>
          <Divider />
          <br />
          {/* Use form tag if needed, but button clicks trigger actions directly */}
          {/* <form onSubmit={formik.handleSubmit}> */}
          <ToastApp />
          <Grid item xs={12} container spacing={2}>
            {/* --- Search Fields --- */}
            <Grid item lg={3} xs={12}>
              <Autocomplete
                disablePortal
                id="doc-select"
                options={DocOption}
                getOptionLabel={(option) => option.label || ""}
                isOptionEqualToValue={(option, value) => {
                  // ⭐ String में compare करें
                  return String(option.value) === String(value?.value);
                }}
                value={
                  // ⭐ String में compare करके ढूंढें
                  DocOption.find((opt) => String(opt.value) === String(formik.values.docMid)) || null
                }
                fullWidth
                size="small"
                onChange={(event, newValue) => {
                  const value = newValue?.value || "";
                  formik.setFieldValue("docMid", String(value));
                  if (value) {
                    getDocMng(String(value), selectedDepartment?.value);
                  }
                }}
                renderInput={(params) => (
                  <TextField {...params} label={t("text.SelectFileNo")} />
                )}
              />
              {/* Removed redundant touched/error logic if not using Yup validation here */}
            </Grid>
            <Grid item lg={3} xs={12}>
              <Autocomplete
                options={departmentOptions}
                getOptionLabel={(option) => option.label || ""}
                value={selectedDepartment}
                onChange={(event, newValue) => {

                  setSelectedDepartment(newValue);

                  if (newValue) {
                    getDocMng(formik.values.docMid, newValue.value);
                  }

                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Department"
                    size="small"
                    fullWidth
                  />
                )}
              />
            </Grid>
            <Grid item md={3} xs={12} style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <input
                type="checkbox"
                checked={selectAllDept}
                onChange={(e) => handleSelectAllDepartment(e.target.checked)}
              />
              <Typography>{t("text.SelectAllInDept")}</Typography>
            </Grid>
            <Grid item md={3} xs={12}>
              <TextField
                type="text"
                InputLabelProps={{ shrink: true }}
                id="textSearch"
                name="textSearch"
                label={t("text.TextSearch")}
                value={formik.values.textSearch}
                placeholder={t("text.TextSearch")}
                size="small"
                fullWidth
                style={{ backgroundColor: "white" }}
                onChange={formik.handleChange}
              // No need for onBlur if not validating on blur
              />
            </Grid>

            {/* <Grid item md={2} xs={12}>
              <TextField
                type="date"
                InputLabelProps={{ shrink: true }}
                id="fDate"
                name="fDate"
                label={t("text.FromDate")}
                value={formik.values.fDate}
                size="small"
                fullWidth
                style={{ backgroundColor: "white" }}
                onChange={formik.handleChange}
              />
            </Grid>

            <Grid item md={2} xs={12}>
              <TextField
                type="date"
                InputLabelProps={{ shrink: true }}
                id="perUt"
                name="perUt"
                label={t("text.PeriodUpto")}
                value={formik.values.perUt}
                size="small"
                fullWidth
                style={{ backgroundColor: "white" }}
                onChange={formik.handleChange}
              />
            </Grid> */}

            <Grid container justifyContent="center" spacing={2} style={{ marginTop: 16 }}>
              <Grid item md={2} xs={12}>
                <Button
                   onClick={() => getDocMng()}   // ✅ FIXED
                  fullWidth
                  variant="contained"
                  style={{
                    backgroundColor: `var(--header-background)`,
                    color: "white",
                    height: "40px",
                  }}
                >
                  {t("text.search")}
                </Button>
                

              </Grid>
               <Grid item md={2} xs={12}>
              <Button 
                  onClick={resetFormUI}
                  fullWidth
                  variant="outlined"  
                  style={{
                  
                 
                    backgroundColor: "#F43F5E",
                
                    color: "white",
                    height: "40px",
                  }}
                >
                  {t("text.reset")}
                </Button>
              </Grid>
            </Grid>

            {/* --- Results Table --- */}
            <Grid item xs={12} mt={2}>
              {tableData.length > 0 ? (
                <>
                  <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                    <Table
                      stickyHeader
                      style={{
                        borderCollapse: "collapse",
                        width: "100%",
                        border: "1px solid #ddd",
                      }}
                    >
                      <thead
                        style={{
                          backgroundColor: `var(--header-background)`,
                          color: `var(--header-color)`,
                        }}
                      >
                        <tr>
                          <th style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>
                            <input
                              type="checkbox"
                              checked={
                                tableData.length > 0 &&
                                tableData
                                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                  .every((row: any) => row.isSelected)
                              }
                              onChange={(e) => handleSelectAll(e.target.checked)}
                            />
                          </th>
                          <th style={{ border: "1px solid #ddd", padding: "8px" }}>
                            {t("text.FileNo")}
                          </th>
                          <th style={{ border: "1px solid #ddd", padding: "8px" }}>
                            {t("text.PdfFileName")}
                          </th>
                          <th style={{ border: "1px solid #ddd", padding: "8px" }}>
                            {t("text.FileName")}
                          </th>
                          <th style={{ border: "1px solid #ddd", padding: "8px" }}>
                            {t("text.FileType")}
                          </th>
                          <th style={{ border: "1px solid #ddd", padding: "8px" }}>
                            {t("text.Department")}
                          </th>
                          {/* <th style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>
                            {t("text.DateFrom")}
                          </th>
                          <th style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>
                            {t("text.DateTo")}
                          </th> */}
                        </tr>
                      </thead>

                      <tbody>
                        {tableData
                          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                          .map((row: any) => (
                            <tr
                              key={row.id}
                              style={{
                                borderBottom: "1px solid #ddd",
                                backgroundColor: row.isSelected ? "#eef" : "white",
                              }}
                            >
                              <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>
                                <input
                                  type="checkbox"
                                  checked={row.isSelected || false}
                                  onChange={(e) =>
                                    handleInputChange(row.id, "isSelected", e.target.checked)
                                  }
                                />
                              </td>
                              <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                                {row.fileNo}
                              </td>
                              <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                                {row.fileDef}
                              </td>
                              <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                                {row.synopsis}
                              </td>
                              <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                                {row.fileType}
                              </td>
                              <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                                {row.division_name}
                              </td>
                              {/* <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>
                                {formatDate(row.fDate)}
                              </td>
                              <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>
                                {formatDate(row.perUt)}
                              </td> */}
                            </tr>
                          ))}
                      </tbody>
                    </Table>
                  </div>

                  {/* Pagination */}
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={tableData.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </>
              ) : (
                <Typography sx={{ textAlign: "center", mt: 3, fontStyle: "italic" }}>
                  {t("text.NoDataFound")}
                </Typography>
              )}
            </Grid>
          </Grid>

          {/* --- Split Button (Only shown if data exists) --- */}
          {tableData.length > 0 && (
            <Grid
              item
              xs={12}
              mt={2} // Add margin top
              style={{ display: "flex", justifyContent: "center" }}
            >
              <Grid item xs={12} sm={6} md={4}>
                {" "}
                {/* Responsive width */}
                <Button
                  onClick={AddSplitPdf}
                  fullWidth
                  variant="contained"
                  disabled={
                    !tableData.some((row: any) => row.isSelected) || isSubmittingSplit
                  }
                  style={{
                    backgroundColor: "var(--header-background)"
                  }}
                >

                  {isSubmittingSplit ? (
                    <CircularProgress size={22} sx={{ color: "#fff" }} />
                  ) : (
                    t("text.SplitPage")
                  )}

                </Button>
              </Grid>
            </Grid>
          )}
          {/* Removed the conditional rendering of the "Go to document indexing" button from here */}
          {/* </form> */}
        </CardContent>
      </div>

      {/* --- Modal for "Go to Document Indexing" --- */}
    <Modal
  open={active}
  onClose={() => setActive(false)}
  sx={{
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    px: 1 // 🔥 mobile side spacing
  }}
>
        <Box sx={modalStyle}>
        <Typography
  variant="h6"
  sx={{
    textAlign: "center",
    fontSize: { xs: "16px", sm: "18px" },
    wordBreak: "break-word"
  }}
>
  Split Request Submitted
</Typography>

       <Box
  sx={{
    display: "flex",
    flexDirection: { xs: "column", sm: "row" }, // 🔥 mobile stack
    gap: 2,
    width: "100%"
  }}
>
  <Button
    fullWidth
    variant="contained"
    onClick={handleGoToIndexing}
    sx={{
      backgroundColor: `var(--header-background)`,
      color: `var(--header-color)`
    }}
  >
    New Indexing
  </Button>

  <Button
    fullWidth
    variant="outlined"
    onClick={() => setActive(false)}
  >
    Close
  </Button>
</Box>
        </Box>
      </Modal>
    </> // End of React Fragment
  );
};

export default SplitPDF;



// import {
//   Button,
//   Card,
//   CardContent,
//   Grid,
//   TextField,
//   Typography,
//   Divider,
//   Modal, // Keep Modal
//   Box,   // Keep Box
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Table,
// } from "@mui/material";
// import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import HOST_URL from "../../../utils/Url";
// import { useFormik } from "formik";
// import * as Yup from "yup";
// import { useTranslation } from "react-i18next";
// import { toast } from "react-toastify";
// import ToastApp from "../../../ToastApp";
// import Autocomplete from "@mui/material/Autocomplete";
// import { Margin } from "@mui/icons-material";
// import nopdf from '../../../assets/images/nopdf.png'
// import moment from 'moment';
// import { getSecureDevId } from "../../../utils/storageHelpers";
// import TablePagination from "@mui/material/TablePagination";
// import CircularProgress from "@mui/material/CircularProgress";
// import { useLocation } from "react-router-dom";
// // Define the style for the modal content box
// const modalStyle = {
//   position: "absolute" as "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: { xs: '90%', sm: '60%', md: '400px' }, // Responsive width
//   bgcolor: "background.paper", // Use theme background
//   border: '1px solid #ccc',
//   borderRadius: '8px', // Add rounded corners
//   boxShadow: 24,
//   p: 4, // Padding
//   textAlign: 'center', // Center text/button inside
// };

// type Props = {};

// const SplitPDF = (props: Props) => {

//   const [selectedRows, setSelectedRows] = useState<any>([]);
//   const [selectedRow, setSelectedRow] = useState<any>([]);

//   let navigate = useNavigate();
//   const { i18n, t } = useTranslation();
//   const location = useLocation();
//   const [isSubmittingSplit, setIsSubmittingSplit] = useState(false);
//   const [toaster, setToaster] = useState(false);
//   const [tableData, setTableData] = useState<any>([]);
//   const [DocFileOption, setDocFileOption] = useState([{ value: "-1", label: t("text.SelectFileType") }]);
//   const [StatusOption, setStatusOption] = useState([{ value: "-1", label: t("text.SelectFileStatus") }]);
//   const [DocOption, setDocOption] = useState([{ value: "-1", label: t("text.SelectFileNo") }]);

//   const [departmentOptions, setDepartmentOptions] = useState<any[]>([]);
//   const [selectedDepartment, setSelectedDepartment] = useState<any>(null);

//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(5);
//   // State to control modal visibility and background blur
//   const [active, setActive] = useState(false);
//   const [splitSuccessData, setSplitSuccessData] = useState<any[]>([]);

//   const devId = getSecureDevId();

//   function formatDate(dateString: any) {
//     if (!dateString) return ""; // Return empty string if date is not provided
//     return moment(dateString).format('DD-MM-YYYY');
//   }

//   useEffect(() => {
//     const dataString = localStorage.getItem("userdata");
//     getFileType();
//     getFileStatus();
//     getDoc();
//     fetchDepartments();
//   }, []);


//   // SplitPDF.tsx में - यह useEffect पहले से होना चाहिए
//   // useEffect(() => {
//   //   if (location.state?.selectedDocMids && location.state.selectedDocMids.length > 0 && DocOption.length > 1) {
//   //     const selectedMids = location.state.selectedDocMids;
//   //     const targetId = selectedMids[0];

//   //     console.log("🟢 Target ID:", targetId, "type:", typeof targetId);

//   //     // Loop through all options to find match
//   //     let matchedOption = null;
//   //     for (let i = 0; i < DocOption.length; i++) {
//   //       const opt = DocOption[i];
//   //       // Compare as string
//   //       if (String(opt.value) === String(targetId)) {
//   //         matchedOption = opt;
//   //         break;
//   //       }
//   //       // Compare as number
//   //       if (Number(opt.value) === Number(targetId)) {
//   //         matchedOption = opt;
//   //         break;
//   //       }
//   //     }

//   //     console.log("🟢 Matched Option:", matchedOption);

//   //     if (matchedOption) {
//   //       formik.setFieldValue("docMid", String(matchedOption.value));
//   //       setTimeout(() => {
//   //         getDocMng(String(matchedOption.value), selectedDepartment?.value);
//   //       }, 500);
//   //       window.history.replaceState({}, document.title);
//   //     } else {
//   //       // अगर match नहीं मिला, तो DocOption का पहला कुछ ऑप्शन दिखाएँ
//   //       console.log("🟢 Sample options:", DocOption.slice(0, 10).map(opt => ({ value: opt.value, type: typeof opt.value })));
//   //     }
//   //   }
//   // }, [location, DocOption]);

//   useEffect(() => {
//     if (location.state?.selectedDocMids && location.state.selectedDocMids.length > 0 && DocOption.length > 1) {
//       const selectedMids = location.state.selectedDocMids;
//       const targetId = selectedMids[0];

//       let matchedOption = null;
//       for (let i = 0; i < DocOption.length; i++) {
//         const opt = DocOption[i];
//         // Compare as string OR number
//         if (String(opt.value) === String(targetId) || Number(opt.value) === Number(targetId)) {
//           matchedOption = opt;
//           break;
//         }
//       }

//       console.log("🟢 Matched Option:", matchedOption);

//       if (matchedOption) {
//         // ⭐ Important: value को string में store करें
//         // Autocomplete compare के लिए string ही use करें
//         const valueToSet = String(matchedOption.value);
//         formik.setFieldValue("docMid", valueToSet);

//         console.log("🟢 formik.values.docMid set to:", valueToSet);
//         console.log("🟢 Type of formik.values.docMid:", typeof valueToSet);

//         setTimeout(() => {
//           getDocMng(valueToSet, selectedDepartment?.value);
//         }, 500);

//         window.history.replaceState({}, document.title);
//       }
//     }
//   }, [location, DocOption]);

//   // State to track whether "Select All in Department" is checked
//   const [selectAllDept, setSelectAllDept] = useState(false);

//   // Function to select/unselect all rows of selected department
//   const handleSelectAllDepartment = (checked: boolean) => {
//     setSelectAllDept(checked); // update the checkbox state

//     if (!selectedDepartment) {
//       toast.warning("Please select a department first.");
//       return;
//     }

//     setTableData((prevTableData: any) =>
//       prevTableData.map((row: any) =>
//         row.divisionid === selectedDepartment.value
//           ? { ...row, isSelected: checked }
//           : row
//       )
//     );
//   };

//   const handleChangePage = (event: unknown, newPage: number) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (
//     event: React.ChangeEvent<HTMLInputElement>
//   ) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };
//   const getDocMng = (docId?: any, deptId?: any) => {

//   // ✅ FIX: agar event aa gaya to ignore
//   if (docId && typeof docId === "object") {
//     docId = undefined;
//   }

//   const collectData = {
//     modal: "",
//     fromDate: formik.values.fDate || "",
//     toDate: formik.values.perUt || "",
//     filestatus: "",
//     textSearch: formik.values.textSearch || "",

//     docMid: String(docId ?? formik.values.docMid ?? ""), // ✅ key line

//     fileTypId: "",
//     divisionid: String(deptId ?? selectedDepartment?.value ?? ""),
//     user_Id: -1
//   };

//   console.log("🔥 PAYLOAD:", collectData);
//     axios
//       .post(HOST_URL.HOST_URL2 + `DocMangr/GetDocMangrForIndex`, collectData)
//       .then((res) => {

//         const arr = res.data.data.map((item: any) => ({
//           id: item.pdFid,
//           fileNo: item.fileNo,
//           docMid: item.docMid,
//           fileDef: item.fileDef,
//           synopsis: item.synopsis,
//           fileType: item.fileType,
//           subject: item.subject,
//           pdfName: item.pdfName,
//           pdFid: item.pdFid,
//           divisionid: item.divisionid,
//           division_name: item.division_name,
//           isSelected: false
//         }));

//         setTableData(arr);

//       })
//       .catch((error) => {

//         console.error(error);
//         toast.error("Failed to fetch documents");

//       });
//   };
//   const resetFormUI = () => {

//     // formik reset
//     formik.resetForm();

//     // department reset
//     setSelectedDepartment(null);

//     // table reset
//     setTableData([]);

//     // checkbox reset
//     setSelectAllDept(false);

//     // pagination reset
//     setPage(0);

//   };
//   const AddSplitPdf = async () => {

//     let array1: any[] = [];
//     let hasSelection = false;

//     for (let row of tableData) {

//       if (row.isSelected) {

//         hasSelection = true;

//         array1.push({
//           docMid: row.docMid,
//           divisionid: row.divisionid,
//           docMangrSplits: [
//             {
//               chkSplit: true,
//               pdfName: row.pdfName,
//               pdFid: row.pdFid
//             }
//           ]
//         })

//       }

//     }

//     if (!hasSelection) {
//       toast.warning("Please select at least one PDF");
//       return;
//     }

//     const collectData = {
//       docMangrReqForSplit: array1
//     }

//     try {

//       setIsSubmittingSplit(true);

//       const response = await axios.post(
//         HOST_URL.HOST_URL2 + `SplitPdf/AddUpdateSplitPdf`,
//         collectData
//       );

//       if (response.data.status === 1) {

//         toast.success("Split request submitted successfully!");

//         // 👇 नया कोड: स्प्लिट की गई फाइलों की docMid इकट्ठा करें
//         const selectedDocMids = array1.map(item => item.docMid);
//         setSplitSuccessData(selectedDocMids); // state में सेव करें
//         // 👆 नया कोड समाप्त
//         setActive(true);

//         // checkbox reset
//         setTableData((prev: any[]) =>
//           prev.map(row => ({
//             ...row,
//             isSelected: false
//           }))
//         );

//         // ⭐ FULL UI RESET
//         resetFormUI();

//       } else {

//         toast.error(response.data.message || "Error processing split");

//       }

//     }
//     catch (error) {

//       toast.error("Error submitting split request");

//     }
//     finally {

//       setIsSubmittingSplit(false);

//     }

//   };

//   // 👇 यह नया फंक्शन जोड़ें
//   const handleGoToIndexing = () => {
//     navigate('/DocManagement/DocumentIndexing', {
//       state: { selectedDocMids: splitSuccessData }
//     });
//     setActive(false);
//   };

//   const getFileType = () => {
//     const collectData = { docID: -1, parentDocId: -1, userId: "", };
//     axios
//       .post(HOST_URL.HOST_URL2 + `OtherDocType/GetOtherDocType`, collectData)
//       .then((res) => {
//         const arr = res.data.data.map((item: any) => ({
//           label: item.doc_Name,
//           value: item.docID
//         }));
//         setDocFileOption([{ value: "-1", label: t("text.SelectFileType") }, ...arr]); // Add default option back
//       }).catch(err => console.error("Failed to get file types", err));
//   };

//   const getDoc = () => {
//     const collectData = {
//       docMid: -1, fileTypId: -1,
//       //@ts-ignore
//       divisionid: devId === null || devId === "null" ? "" : Number(devId),
//       subsubjId: -1, user_Id: -1, fileNo: "",
//       subDeptID: -1,
//       synopsis: "",
//       complt: ""
//     };
//     axios
//       .post(HOST_URL.HOST_URL2 + `DocMangr/GetDocMangr`, collectData)
//       .then((res) => {
//         const arr = res.data.data.map((item: any) => ({
//           label: item.fileNo ? `${item.fileNo} (${item.synopsis})` : "_ _",
//           value: item.docMid
//         }));
//         setDocOption([{ value: "-1", label: t("text.SelectFileNo") }, ...arr]); // Add default option back
//       }).catch(err => console.error("Failed to get docs", err));
//   };

//   const getFileStatus = () => {
//     const collectData = {};
//     axios
//       .post(HOST_URL.HOST_URL2 + `FileStatus/GetFileStatus`, collectData)
//       .then((res) => {
//         var array = [];
//         for (let index = 0; index < res.data.data.length; index++) {
//           array.push({
//             label: res.data.data[index]["fStatus"],
//             value: res.data.data[index]["fStatus"],
//           });
//         }
//         setStatusOption([{ value: "-1", label: t("text.SelectFileStatus") }, ...array]); // Add default option back
//       }).catch(err => console.error("Failed to get file status", err));
//   };

//   const fetchDepartments = async () => {
//     try {
//       const response = await axios.post(
//         HOST_URL.HOST_URL2 + `NewNodeMaster/GetNewNodeMaster`,
//         {
//           id: -1,
//           nodeID: -1,
//           titleID: -1,
//         }
//       );

//       const departments = response.data.data || [];

//       const deptOptions = departments.map((dept: any) => ({
//         label: dept.name,
//         value: dept.id,
//       }));

//       setDepartmentOptions(deptOptions);

//     } catch (error) {
//       toast.error("Failed to fetch departments");
//     }
//   };

//   const handleInputChange = (id: number, columnName: string, checked: boolean) => {
//     setTableData((prevTableData: any) =>
//       prevTableData.map((row: any) =>
//         row.id === id ? { ...row, [columnName]: checked } : row
//       )
//     );
//   };
//   const handleSelectAll = (checked: boolean) => {
//     const start = page * rowsPerPage;
//     const end = page * rowsPerPage + rowsPerPage;

//     const updatedData = tableData.map((row: any, index: number) => {
//       if (index >= start && index < end) {
//         return { ...row, isSelected: checked };
//       }
//       return row;
//     });

//     setTableData(updatedData);
//   };

//   const formik = useFormik({
//     initialValues: {
//       docMid: "", fDate: "", perUt: "", textSearch: "",
//       // Keep other initial values if needed, but these are the main search ones
//       // ... other fields ...
//       fileNo: "", fileDef: "", synopsis: "", complt: "", fileType: "", subj: "",
//       partNo: "", pFileNo: "", userId: "", perFr: "", authPersn: "",
//       subsubjId: 0, sub_Subject_Name: "", divisionid: 0, division_name: "",
//       filestatus: "", fileTypId: "", createdate: "", user_Id: 1,
//     },
//     onSubmit: async (values) => {
//       // The main action is triggered by the search button (getDocMng)
//       // This onSubmit might not be strictly needed unless you have other form actions
//       console.log("Form submitted (though search is manual)", values);
//     },
//   });

//   // Removed handleCheckboxChange as handleInputChange covers the checkbox state now.

//   const back = useNavigate();

//   return (
//     // Use React Fragment to allow modal as a sibling to the main content div
//     <>
//       {/* Wrap main content for blurring */}
//       <div
//         style={{
//           padding: "-5px 5px",
//           filter: active ? "blur(4px)" : "none", // Apply blur when active
//           transition: "filter 0.3s ease-out", // Smooth transition for blur
//           pointerEvents: active ? "none" : "auto", // Prevent interaction with blurred background
//           // The rest of your existing styles for this div
//           backgroundColor: "#ffffff",
//           borderRadius: "5px",
//           border: ".5px solid #42AEEE",
//           marginTop: "3vh",
//         }}
//       >
//         <CardContent>
//           <Typography
//             variant="h5"
//             textAlign="center"
//             style={{ fontSize: "18px", fontWeight: 500 }}
//           >
//             {t("text.SplitPdfToJump")}
//           </Typography>

//           <Grid item sm={4} xs={12}>
//             <Typography style={{ marginTop: "-75px" }}>
//               <Button
//                 type="button" // Change to button if not submitting form
//                 onClick={() => back(-1)}
//                 variant="contained"
//                 style={{
//                   marginBottom: 15,
//                   marginTop: "45px",
//                   backgroundColor: `var(--header-background)`,
//                   width: 20, // Consider using padding/minWidth for better icon button sizing
//                 }}
//                 aria-label="Go back" // Add aria-label for accessibility
//               >
//                 <ArrowBackSharpIcon />
//               </Button>
//             </Typography>
//           </Grid>
//           <Divider />
//           <br />
//           {/* Use form tag if needed, but button clicks trigger actions directly */}
//           {/* <form onSubmit={formik.handleSubmit}> */}
//           <ToastApp />
//           <Grid item xs={12} container spacing={2}>
//             {/* --- Search Fields --- */}
//             <Grid item lg={3} xs={12}>
//               <Autocomplete
//                 disablePortal
//                 id="doc-select"
//                 options={DocOption}
//                 getOptionLabel={(option) => option.label || ""}
//                 isOptionEqualToValue={(option, value) => {
//                   // ⭐ String में compare करें
//                   return String(option.value) === String(value?.value);
//                 }}
//                 value={
//                   // ⭐ String में compare करके ढूंढें
//                   DocOption.find((opt) => String(opt.value) === String(formik.values.docMid)) || null
//                 }
//                 fullWidth
//                 size="small"
//                 onChange={(event, newValue) => {
//                   const value = newValue?.value || "";
//                   formik.setFieldValue("docMid", String(value));
//                   if (value) {
//                     getDocMng(String(value), selectedDepartment?.value);
//                   }
//                 }}
//                 renderInput={(params) => (
//                   <TextField {...params} label={t("text.SelectFileNo")} />
//                 )}
//               />
//               {/* Removed redundant touched/error logic if not using Yup validation here */}
//             </Grid>
//             <Grid item lg={3} xs={12}>
//               <Autocomplete
//                 options={departmentOptions}
//                 getOptionLabel={(option) => option.label || ""}
//                 value={selectedDepartment}
//                 onChange={(event, newValue) => {

//                   setSelectedDepartment(newValue);

//                   if (newValue) {
//                     getDocMng(formik.values.docMid, newValue.value);
//                   }

//                 }}
//                 renderInput={(params) => (
//                   <TextField
//                     {...params}
//                     label="Select Department"
//                     size="small"
//                     fullWidth
//                   />
//                 )}
//               />
//             </Grid>
//             <Grid item md={3} xs={12} style={{ display: "flex", alignItems: "center", gap: "10px" }}>
//               <input
//                 type="checkbox"
//                 checked={selectAllDept}
//                 onChange={(e) => handleSelectAllDepartment(e.target.checked)}
//               />
//               <Typography>{t("text.SelectAllInDept")}</Typography>
//             </Grid>
//             <Grid item md={3} xs={12}>
//               <TextField
//                 type="text"
//                 InputLabelProps={{ shrink: true }}
//                 id="textSearch"
//                 name="textSearch"
//                 label={t("text.TextSearch")}
//                 value={formik.values.textSearch}
//                 placeholder={t("text.TextSearch")}
//                 size="small"
//                 fullWidth
//                 style={{ backgroundColor: "white" }}
//                 onChange={formik.handleChange}
//               // No need for onBlur if not validating on blur
//               />
//             </Grid>

//             {/* <Grid item md={2} xs={12}>
//               <TextField
//                 type="date"
//                 InputLabelProps={{ shrink: true }}
//                 id="fDate"
//                 name="fDate"
//                 label={t("text.FromDate")}
//                 value={formik.values.fDate}
//                 size="small"
//                 fullWidth
//                 style={{ backgroundColor: "white" }}
//                 onChange={formik.handleChange}
//               />
//             </Grid>

//             <Grid item md={2} xs={12}>
//               <TextField
//                 type="date"
//                 InputLabelProps={{ shrink: true }}
//                 id="perUt"
//                 name="perUt"
//                 label={t("text.PeriodUpto")}
//                 value={formik.values.perUt}
//                 size="small"
//                 fullWidth
//                 style={{ backgroundColor: "white" }}
//                 onChange={formik.handleChange}
//               />
//             </Grid> */}

//             <Grid container justifyContent="center" spacing={2} style={{ marginTop: 16 }}>
//               <Grid item md={2} xs={12}>
//                 <Button
//                    onClick={() => getDocMng()}   // ✅ FIXED
//                   fullWidth
//                   variant="contained"
//                   style={{
//                     backgroundColor: `var(--header-background)`,
//                     color: "white",
//                     height: "40px",
//                   }}
//                 >
//                   {t("text.search")}
//                 </Button>
                

//               </Grid>
//                <Grid item md={2} xs={12}>
//               <Button 
//                   onClick={resetFormUI}
//                   fullWidth
//                   variant="outlined"  
//                   style={{
                  
                 
//                     backgroundColor: "#F43F5E",
                
//                     color: "white",
//                     height: "40px",
//                   }}
//                 >
//                   {t("text.reset")}
//                 </Button>
//               </Grid>
//             </Grid>

//             {/* --- Results Table --- */}
//             <Grid item xs={12} mt={2}>
//               {tableData.length > 0 ? (
//                 <>
//                   <div style={{ maxHeight: "400px", overflowY: "auto" }}>
//                     <Table
//                       stickyHeader
//                       style={{
//                         borderCollapse: "collapse",
//                         width: "100%",
//                         border: "1px solid #ddd",
//                       }}
//                     >
//                       <thead
//                         style={{
//                           backgroundColor: `var(--header-background)`,
//                           color: `var(--header-color)`,
//                         }}
//                       >
//                         <tr>
//                           <th style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>
//                             <input
//                               type="checkbox"
//                               checked={
//                                 tableData.length > 0 &&
//                                 tableData
//                                   .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
//                                   .every((row: any) => row.isSelected)
//                               }
//                               onChange={(e) => handleSelectAll(e.target.checked)}
//                             />
//                           </th>
//                           <th style={{ border: "1px solid #ddd", padding: "8px" }}>
//                             {t("text.FileNo")}
//                           </th>
//                           <th style={{ border: "1px solid #ddd", padding: "8px" }}>
//                             {t("text.PdfFileName")}
//                           </th>
//                           <th style={{ border: "1px solid #ddd", padding: "8px" }}>
//                             {t("text.FileName")}
//                           </th>
//                           <th style={{ border: "1px solid #ddd", padding: "8px" }}>
//                             {t("text.FileType")}
//                           </th>
//                           <th style={{ border: "1px solid #ddd", padding: "8px" }}>
//                             {t("text.Department")}
//                           </th>
//                           {/* <th style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>
//                             {t("text.DateFrom")}
//                           </th>
//                           <th style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>
//                             {t("text.DateTo")}
//                           </th> */}
//                         </tr>
//                       </thead>

//                       <tbody>
//                         {tableData
//                           .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
//                           .map((row: any) => (
//                             <tr
//                               key={row.id}
//                               style={{
//                                 borderBottom: "1px solid #ddd",
//                                 backgroundColor: row.isSelected ? "#eef" : "white",
//                               }}
//                             >
//                               <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>
//                                 <input
//                                   type="checkbox"
//                                   checked={row.isSelected || false}
//                                   onChange={(e) =>
//                                     handleInputChange(row.id, "isSelected", e.target.checked)
//                                   }
//                                 />
//                               </td>
//                               <td style={{ border: "1px solid #ddd", padding: "8px" }}>
//                                 {row.fileNo}
//                               </td>
//                               <td style={{ border: "1px solid #ddd", padding: "8px" }}>
//                                 {row.fileDef}
//                               </td>
//                               <td style={{ border: "1px solid #ddd", padding: "8px" }}>
//                                 {row.synopsis}
//                               </td>
//                               <td style={{ border: "1px solid #ddd", padding: "8px" }}>
//                                 {row.fileType}
//                               </td>
//                               <td style={{ border: "1px solid #ddd", padding: "8px" }}>
//                                 {row.division_name}
//                               </td>
//                               {/* <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>
//                                 {formatDate(row.fDate)}
//                               </td>
//                               <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>
//                                 {formatDate(row.perUt)}
//                               </td> */}
//                             </tr>
//                           ))}
//                       </tbody>
//                     </Table>
//                   </div>

//                   {/* Pagination */}
//                   <TablePagination
//                     rowsPerPageOptions={[5, 10, 25]}
//                     component="div"
//                     count={tableData.length}
//                     rowsPerPage={rowsPerPage}
//                     page={page}
//                     onPageChange={handleChangePage}
//                     onRowsPerPageChange={handleChangeRowsPerPage}
//                   />
//                 </>
//               ) : (
//                 <Typography sx={{ textAlign: "center", mt: 3, fontStyle: "italic" }}>
//                   {t("text.NoDataFound")}
//                 </Typography>
//               )}
//             </Grid>
//           </Grid>

//           {/* --- Split Button (Only shown if data exists) --- */}
//           {tableData.length > 0 && (
//             <Grid
//               item
//               xs={12}
//               mt={2} // Add margin top
//               style={{ display: "flex", justifyContent: "center" }}
//             >
//               <Grid item xs={12} sm={6} md={4}>
//                 {" "}
//                 {/* Responsive width */}
//                 <Button
//                   onClick={AddSplitPdf}
//                   fullWidth
//                   variant="contained"
//                   disabled={
//                     !tableData.some((row: any) => row.isSelected) || isSubmittingSplit
//                   }
//                   style={{
//                     backgroundColor: "var(--header-background)"
//                   }}
//                 >

//                   {isSubmittingSplit ? (
//                     <CircularProgress size={22} sx={{ color: "#fff" }} />
//                   ) : (
//                     t("text.SplitPage")
//                   )}

//                 </Button>
//               </Grid>
//             </Grid>
//           )}
//           {/* Removed the conditional rendering of the "Go to document indexing" button from here */}
//           {/* </form> */}
//         </CardContent>
//       </div>

//       {/* --- Modal for "Go to Document Indexing" --- */}
//       <Modal
//         open={active}
//         onClose={() => setActive(false)} // Optional: Allow closing modal by clicking backdrop
//         aria-labelledby="split-success-modal-title"
//         aria-describedby="split-success-modal-description"
//       >
//         <Box sx={modalStyle}>
//           <Typography
//             id="split-success-modal-title"
//             variant="h6"
//             component="h2"
//           >
//             Split Request Submitted
//           </Typography>

//           <Button
//             variant="contained"
//             onClick={handleGoToIndexing}  // नया फंक्शन कॉल करेगा
//             style={{
//               backgroundColor: `var(--header-background)`,
//               color: `var(--header-color)`,
//             }}
//           >
//             New Indexing
//           </Button>
//           <Button
//             variant="outlined"
//             onClick={() => setActive(false)} // Add a close button
//             style={{ marginLeft: "10px" }}
//           >
//             Close
//           </Button>
//         </Box>
//       </Modal>
//     </> // End of React Fragment
//   );
// };

// export default SplitPDF;